import { fork } from 'redux-saga/effects'
import startup from './startup'
import authentication from './authentication'
import detectMobile from './detectMobile'
import reservation from './reservation'
import conference from './conference'
import userProfileHistory from './userProfileHistory'
import paymentHistory from './paymentHistory'
import myrecordsUsage from './myRecordsUsage'
import cloudRecords from './cloudRecords'

function* rootSata() {
    yield fork(startup);
    yield fork(authentication)
    yield fork(detectMobile)
    yield fork(reservation)
    yield fork(conference)
    yield fork(userProfileHistory)
    yield fork(paymentHistory)
    yield fork(myrecordsUsage)
    yield fork(cloudRecords)
}

export default rootSata;